export default "__VITE_ASSET__1cFuEapL__"